export const COMPANY_INFO: CompanyInfo = {
    name: "Company Name",
    address: "Company Address",
    phone: "Company Phone",
    email: "Company Email",
    website: "Company Website",
    logo: "Company Logo",
    slogan: "Company Slogan",
    social_media: {
        facebook: "Facebook",
        twitter: "https://twitter.com/passtickets",
        instagram: "https://www.instagram.com/passtickets/",
        threads: "https://www.threads.net/@passtickets",
        linkedin: "https://www.linkedin.com/company/starthub.io",
        youtube: "Youtube",
        snapchat: "Snapchat",
        whatsapp: "Whatsapp",
        tiktok: "https://www.tiktok.com/@officialpasstickets",
    },
}

export type CompanyInfo = {
    name: string
    address: string
    phone: string
    email: string
    website: string
    logo: string
    slogan: string
    social_media: SocialMedia
}

export type SocialMedia = {
    facebook: string
    twitter: string
    instagram: string
    linkedin: string
    youtube: string
    snapchat: string
    whatsapp: string
    threads: string
    tiktok: string
}
